export default class PathWorker {
  constructor(path) {
    this.path = path
  }

  get getMedicineId() {
    return Number(this.path.params.id)
  }
}
